import { render, staticRenderFns } from "./WalkTracker.vue?vue&type=template&id=50dd8bc4&scoped=true"
import script from "./WalkTracker.vue?vue&type=script&lang=js"
export * from "./WalkTracker.vue?vue&type=script&lang=js"
import style0 from "./WalkTracker.vue?vue&type=style&index=0&id=50dd8bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd8bc4",
  null
  
)

export default component.exports